export default __webpack_public_path__ + "static/media/city-bg.7007f47d.png";